<template lang="pug">
  el-dialog(
    v-if="getUsuarioLogado"
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    class="custom-dialog-perfil"
    top="10vh"
    title="Informações do Usuário"
  )
    .user-info
      .area-conteudo.border-b
        .close(@click="setModalPerfil(false)")
          i.el-icon-circle-close
        .area-imagem(@click="selectImage")
          img(:src="localFoto || fotoAtual" alt="User Photo" class="user-photo")
          label.file-upload
            input(type="file" ref="fileInput" @change="onPhotoSelected")
        .info-usuario.mb-1
          .label-info-usuario 
            label Nome:
            p {{ getUsuarioLogado.nome }}
          .label-info-usuario
            label CPF/CNPJ:
            p {{ formatCpfCnpj(getUsuarioLogado.cpf_cnpj) || '-' }}
        .info-usuario.column.mb-1
          .label-info-usuario 
            label Email:
            p {{ getUsuarioLogado.email }}
        .info-usuario.mb-3.pb-3.border-b
          .label-info-usuario 
            label Celular:
            p {{ formatPhone(getUsuarioLogado.celular) || '-' }}
          .label-info-usuario 
            label Telefone:
            p {{ formatPhone(getUsuarioLogado.telefone) || '-' }}
        .info-usuario.mb-4.border-b.pb-3
          .label-info-usuario 
            label Endereço:
            p {{ getUsuarioLogado.endereco || '-' }}
          .label-info-usuario
            label CEP:
            p {{ formatCep(getUsuarioLogado.cep) || '-' }}
          .label-info-usuario 
            label Bairro:
            p {{ getUsuarioLogado.bairro || '-' }}
          .label-info-usuario 
            label Cidade:
            p {{ getUsuarioLogado.cidade ? `${getUsuarioLogado.cidade}, ${getUsuarioLogado.uf}` : '-' }}
        .info-usuario
          .label-info-usuario 
            label Link Site:
            component(:is="!getUsuarioLogado.link_site ? 'p': 'a'" target="_blank" :href="getUsuarioLogado.link_site") {{ getUsuarioLogado.link_site || '-' }}
      .editar
        el-button(type="primary" class="py-2" @click="editar") Editar Infomações
        el-button(type="warning" class="py-2" @click="setAlterarSenha(true)" plain) Alterar Senha
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import LoginGoogle from '../LoginGoogle.vue'

export default {
name: 'ModalPerfil',

components: {
  LoginGoogle
},

data() {
  return {
    currentDialogWidth: this.calculateDialogWidth(),
    localFoto: null
  }
},
computed: {
  ...mapGetters({
    getModalPerfil: 'modais/getPerfil',
    getUsuarioLogado: 'usuario/user'
  }),
  dialogVisible: {
    get(){
      return this.getModalPerfil
    },
    set(newValue){
      this.setModalPerfil(newValue)
    }
  },
  dialogWidth() {
    return this.currentDialogWidth;
  },
  fotoAtual(){
    if(this.getUsuarioLogado && this.getUsuarioLogado.path_imagem) return this.getUsuarioLogado.path_imagem
    else return require('@/assets/avatar.svg')
  }
},

watch: {
  dialogVisible(){
    if(!this.dialogVisible) this.localFoto = null
  }
},

methods: {
  ...mapMutations({
    setLoading: 'globais/setLoading',
    setModalPerfil: 'modais/setPerfil',
    setEdicaoInformacoes: 'modais/setEdicaoInformacoes',
    setAlterarSenha: 'modais/setAlterarSenha'
  }),
  ...mapActions({
    alterarImagem: 'usuario/alterarImagem',
    getUsuario: 'usuario/getUsuario'
  }),

  calculateDialogWidth() {
    return window.innerWidth < 576 ? '90%' : '25%'
  },

  selectImage() {
    this.$refs.fileInput.click()
  },
  handleResize() {
    this.currentDialogWidth = this.calculateDialogWidth()
  },
  onPhotoSelected(event) {
    this.localFoto = null
    this.setLoading(true)
    const file = event.target.files[0]
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        this.localFoto = e.target.result
      };
      reader.readAsDataURL(file)
      this.alterarImagem(file)
      .then(() => {
        this.getUsuario()
        .then(() => {
          this.setLoading(false)
          this.$message({
            message: 'Imagem alterada com sucesso!',
            type: 'success'
          })
        })
        .catch(err => {
          this.setLoading(false)
          this.$message.error(err.response.data)
        })
      })
      .catch(err => {
        this.setLoading(false)
        this.$message.error(err.response.data)
      })
    }
  },
  editar(){
    this.setEdicaoInformacoes(true)
    this.setModalPerfil(false)
  },
  formatCpfCnpj(value) {
    if (!value) return '';
    if (value.length === 11) {
      return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  },
  formatPhone(value) {
    if (!value) return '';
    if (value.length === 10) {
      return value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    } else {
      return value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }
  },
  formatCep(value) {
    if (!value) return '';
    return value.replace(/(\d{5})(\d{3})/, '$1-$2');
  }
},

mounted() {
  window.addEventListener('resize', this.handleResize);
},
beforeDestroy() {
  window.removeEventListener('resize', this.handleResize);
}
};
</script>

<style lang="scss">
.custom-dialog-perfil {
  background: rgba(0, 0, 0, .6);
  .el-dialog__header{
    display: none;
  }
  .border-b{
    border-bottom: 1px solid #282828;
  }
  .el-dialog {
    border-radius: 10px;

    .el-dialog__header{
      padding: 20px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #bcb8b8;

      .el-dialog__headerbtn{
        top: 19px;

        i{
          font-size: 30px;
        }
      }
    }

    .el-dialog__body{
      padding: 15px 15px !important;

      .user-info {
        .area-conteudo{
          display: flex;
          align-items: center;
          flex-direction: column;
  
          .area-imagem{
            cursor: pointer;
            margin-right: 20px;
            margin-top: -70px;
            position: relative;
            width: 130px;
            height: 130px;
            border-radius: 50%;
            margin-bottom: 20px;
            border: 1px solid #fff;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 50%;
              position: relative !important;
            }
            &::after {
              position: absolute;
              content: '';
              top: 0px;
              left: 0px;
              width: 100%;
              height: 100%;
              border-radius: 50%;
              background-color: rgba(0, 0, 0, 0.5);
              background-image: url('@/assets/icons/edit.svg');
              background-repeat: no-repeat;
              background-position: center;
              opacity: 0;
              transition: opacity 0.3s ease
            }
            &:hover::after {
              opacity: 1;
            }
    
            .file-upload {
              display: none;
            }
          }
          
          .column{
            grid-template-columns: 1fr !important;
          }
          .info-usuario{
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 10px;
            .label-info-usuario{
              word-break: break-word;
              font-size: 12px;
              label{
                font-weight: 300;
                font-size: 14px;
                color: #ffffffbd;
              }
              
              p {
                font-size: 13px;
                color: #696969;
                margin: -3px 0 2px 0;
                font-size: 14px;
                font-weight: 300;
              }
            }
          }
        }
        .editar{
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        }
      }      
    }

    .el-dialog__footer {
      .dialog-footer {
        display: flex;
        justify-content: center;
        gap: 10px;
      }
    }
  }
  .close{
    position: absolute;
    top: -10px;
    right: -10px;
    cursor: pointer;
    i{
      font-size: 30px;
      color: #2888c7;
    }
  }
}
</style>
